import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import S from './MobileHeader.module.css';

import { blackArrow, downLogo, blogLogo, mainLogo, spLogo, referenceLogo, headerMenuIcon } from '../../assets/images/header/headerImages';

const MobileHeader = () => {

  const [isMenuVisible, setMenuVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const handleMenuIconClick = () => {
    setMenuVisible(!isMenuVisible);
  }

  const handleMenuClick = (index) => {
    setOpenIndex(prevIndex => prevIndex === index ? null : index);
  }

  const handleHeaderblackArrow = (e) => {
    return(
        <img className='mainHeaderblackArrow' src={blackArrow} alt='화살표' style={{'width':'7px', 'height':'7px'}}/>
    );
  }

  const handleLinkClick = () => {
    setMenuVisible(false);
  }

  return (
    <div className={`${S.header} header`}>

      <div id='headerContent'>
        <Link className='text-line-none flex-row center' to={'https://rfemfo.co.kr/uploads/reference/file/bro_down.pdf'} target='_blank'>
          <div className='flex-row'>
            <img id='downIcon' src={downLogo} alt='제품소개서' />
          </div>
        </Link>
        <div id='headerConLine'></div>        
        <Link className='text-line-none flex-row center' to={'https://rfemfo.co.kr/support/reference'} target='_blank'>
          <div className='flex-row'>
            <img id='referenceIcon' src={referenceLogo} alt='자료실' />
          </div>
        </Link>        
        <div id='headerConLine'></div>
        <Link className='text-line-none flex-row center' to={'https://mkt.shopping.naver.com/link/682a902c814c2c37cf005fcb'} target='_blank'>
          <div id='spIconDiv'>
            <img id='spIcon' src={spLogo} alt='쇼핑몰' />
          </div>
        </Link>        
        <div id='headerConLine'></div>
        <Link className='text-line-none flex-row center' to={'https://m.blog.naver.com/PostList.naver?blogId=emfosky&from=postList&categoryNo=11'} target='_blank'>
          <div className='flex-row'>
            <img id='blogIcon' src={blogLogo} alt='블로그' />
          </div>
        </Link>
      </div>

      <div id={S.headerLogoContent}>
        <Link to={'/'} className='text-line-none'>
          <div id={`${S.headerLogo}`} >
            <img src={mainLogo} id='mainLogo'/>
          </div>
        </Link>
        <div id={S.headerIconDiv} onClick={handleMenuIconClick}>
          <img id='heaer-menu-btn' src={headerMenuIcon} />
        </div>
      </div>

      {isMenuVisible && (
        <div id={S.headerMenuWrap}>
          <Link to={'/'} className='text-line-none' onClick={handleLinkClick}>
            <div className={S.headerMenuDiv}>메인페이지</div>
          </Link>
          <div className={S.headerMenuDiv} onClick={() => handleMenuClick(0)}>
            Company {handleHeaderblackArrow()}
          </div>
          <div className={`${openIndex === 0 ? S.active : S.dNone}`}>
            <Link to={'/company/info'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>회사개요</div>
            </Link>
            <Link to={'/company/ceo'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>CEO 인사말</div>
            </Link>
            <Link to={'/company/history'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>연혁</div>
            </Link>
            <Link to={'/company/certList'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>인증현황</div>
            </Link>
            <Link to={'/company/ci'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>CI 소개</div>
            </Link>
            <Link to={'/company/way'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>오시는 길</div>
            </Link>
          </div>

          <div className={S.headerMenuDiv} onClick={() => handleMenuClick(1)}>
            RFID / NFC {handleHeaderblackArrow()}
          </div>
          <div className={`${openIndex === 1 ? S.active : S.dNone}`}>
            <Link to={'/rfid-nfc/info'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>RFID/NFC 개요</div>
            </Link>
            <Link to={'/rfid-nfc/chip'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>CHIP 종류</div>
            </Link>
          </div>

          <Link to={'/product/list?list=1&pageIdx=1'} className='text-line-none' onClick={handleLinkClick}>
            <div className={S.headerMenuDiv}>
              PRODUCT
            </div>
          </Link>

          <div className={S.headerMenuDiv} onClick={() => handleMenuClick(3)}>
            SOLUTION {handleHeaderblackArrow()}
          </div>
          <div className={`${openIndex === 3 ? S.active : S.dNone}`}>
            <Link to={'/solution/attend'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>근태관리솔루션</div>
            </Link>
            <Link to={'/solution/school'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>등하원관리솔루션</div>
            </Link>
            <Link to={'/solution/nfc'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>NFC 인코딩솔루션</div>
            </Link>
            <Link to={'/solution/rfid'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>RFID R/W 솔루션</div>
            </Link>
            <Link to={'/solution/tag'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>900Mhz 인코딩 솔루션</div>
            </Link>
            <Link to={'/solution/cardprint'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>RFID/NFC 카드인쇄</div>
            </Link>                        
          </div>

          <div className={S.headerMenuDiv} onClick={() => handleMenuClick(4)}>
            PORTFOLIO {handleHeaderblackArrow()}
          </div>
          <div className={`${openIndex === 4 ? S.active : S.dNone}`}>
            <Link to={'/portfolio/partner/1'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>주요납품 소개</div>
            </Link>
            <Link to={'/portfolio/delivery/1'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>납품 갤러리</div>
            </Link>
          </div>

          <div className={S.headerMenuDiv} onClick={() => handleMenuClick(5)}>
            SUPPORT {handleHeaderblackArrow()}
          </div>
          <div className={`${openIndex === 5 ? S.active : S.dNone}`}>
            <Link to={'/support/notice/1'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>공지사항</div>
            </Link>
            <Link to={'/support/inquiry/1'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>온라인 문의</div>
            </Link>
            <Link to={'/support/buy'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>결제 하기</div>
            </Link>
            <Link to={'/support/remote'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>원격 지원</div>
            </Link>
            <Link to={'/support/reference'} className='text-line-none' onClick={handleLinkClick}>
              <div className={S.headerSubMenuDiv}>자료실</div>
            </Link>
          </div>
        </div>
      )}

    </div>
  );
};

export default MobileHeader;
